module.exports = __webpack_public_path__ + "media/team_photos/Hofmann-Anton-photo-be14a21f.webp";